<template>
  <div>
    <template v-if="selectedFlag">
      <shipblu-button size="small" :textButton="`${$t('Download Labels')} (${selected.length})`" :iconStyle="{iconPosition:'left', LeftIconName: 'DownloadIcon', LeftIconLibrary: 'feather'}" @click="downloadShipments()" class="w-full"/>
    </template>
    <template v-else>
      <vx-tooltip position="bottom" color="warning" :text="`${$t('Please select order you want to download!')}`">
        <shipblu-button size="small" :textButton="$t('Download Labels')" :iconStyle="{iconPosition:'left', LeftIconName: 'DownloadIcon', LeftIconLibrary: 'feather'}" :disabled="true" class="w-full"/>
      </vx-tooltip>
    </template>
  </div>
</template>

<script>
export default {
  props: ['selected'],
  data () {
    return {
      headerTitle: ['Tracking Number', 'Merchant Order Reference', 'Packages'],
      headerVal: ['tracking_number', 'merchant_order_reference', 'packages'],
      selectedFlag: false
    }
  },
  watch: {
    selected (val) {
      if (val.length !== 0) {
        this.selectedFlag = true
      } else {
        this.selectedFlag = false
      }
    }
  },
  methods: {
    downloadShipments () {
      import('@/vendor/Export2Excel').then(excel => {
        const list = this.selected
        const data = this.formatJson(this.headerVal, list)
        excel.export_json_to_excel({
          header: this.headerTitle,
          data,
          filename: 'Shipments-Labels',
          autoWidth: true
        })
      })
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        switch (j) {
        case 'packages':
          return v[j] ? v[j].map(element => `1${element.package.id}-${v.id}-${element.package.fragile ? 't' : 'f'}`) : ''
        }
        return v[j]
      }))
    }
  }
}
</script>